import styled from 'styled-components'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'

export const FirstBlockWrapperStyled = styled(FirstBlockWrapper)`
  overflow: hidden;
  background: ${p => p.theme.colors.grayOp06NonTransp};
`
